
export class Plants {
  public id: number;
  public plantid: string;
  public groupid: string[];
  public alias: string;
  public name: string;
  public address: string;
  public modem: string;
  public latitude: number;
  public longitude: number;
  public planttype: string;
  public email: string;
  public bodyid: string;
  public tag: string;
  public enabled: boolean;

  constructor(
    id: number,
    plantid: string,
    groupid: string[],
    alias: string,
    name: string,
    address: string,
    latitude: number,
    longitude: number,
    modem: string,
    planttype: string,
    email: string,
    bodyid: string,
    tag: string,
    enabled: boolean,
  ) {
    this.id = id;
    this.plantid = plantid;
    this.groupid = groupid;
    this.alias = alias;
    this.name = name;
    this.address = address;
    this.latitude = latitude;
    this.longitude = longitude;
    this.modem = modem;
    this.planttype = planttype;
    this.email = email;
    this.bodyid = bodyid;
    this.tag = tag;
    this.enabled = enabled;
  }

}
